var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05176e-05 2.90909C3.05176e-05 1.30255 1.30258 0 2.90912 0L13.0909 0C14.6975 0 16 1.30255 16 2.90909V13.0909C16 14.6975 14.6975 16 13.0909 16H2.90912C1.30258 16 3.05176e-05 14.6975 3.05176e-05 13.0909V2.90909ZM2.90912 1.45455C2.10516 1.45455 1.45458 2.10513 1.45458 2.90909V13.0909C1.45458 13.8949 2.10516 14.5455 2.90912 14.5455H13.0909C13.8949 14.5455 14.5455 13.8949 14.5455 13.0909V2.90909C14.5455 2.10513 13.8949 1.45455 13.0909 1.45455H2.90912ZM3.84946 4.57673C4.13355 4.29264 4.59379 4.29264 4.87786 4.57673L7.78695 7.48582C8.07104 7.76991 8.07104 8.23015 7.78695 8.51422L4.87786 11.4233C4.59377 11.7074 4.13353 11.7074 3.84946 11.4233C3.56539 11.1392 3.56537 10.679 3.84946 10.3949L6.24434 8.00004L3.84946 5.60517C3.56537 5.32107 3.56537 4.8608 3.84946 4.57673ZM8.00003 10.1818C7.59804 10.1818 7.27276 10.5071 7.27276 10.9091C7.27276 11.3111 7.59803 11.6364 8.00003 11.6364H11.6364C12.0384 11.6364 12.3637 11.3111 12.3637 10.9091C12.3637 10.5071 12.0384 10.1818 11.6364 10.1818H8.00003Z",
    fill: "#A0A3A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language_icon.bc42050dcf842e7e19cd5f791539bf22.svg";
export { ForwardRef as ReactComponent };